import { useEffect, useState } from 'react';
import type { Team } from '../../types/team';
import { listMyTeams } from './teamApi';

type State = {
  team: Team | null;
  loading: boolean;
  error: Error | null;
};

export function useMyTeam(userId: string | undefined): State {
  const [state, setState] = useState<State>({ team: null, loading: Boolean(userId), error: null });

  useEffect(() => {
    if (!userId) {
      setState({ team: null, loading: false, error: null });
      return;
    }

    let cancelled = false;
    setState((prev) => ({ ...prev, loading: true, error: null }));

    listMyTeams(userId)
      .then((teams) => {
        if (cancelled) return;
        setState({ team: teams[0] ?? null, loading: false, error: null });
      })
      .catch((err: Error) => {
        if (cancelled) return;
        setState({ team: null, loading: false, error: err });
      });

    return () => {
      cancelled = true;
    };
  }, [userId]);

  return state;
}
